var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropdownOutline20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.167 7.278a.75.75 0 011.055-.11L10 11.034l4.778-3.868a.75.75 0 01.944 1.166l-5.25 4.25a.75.75 0 01-.944 0l-5.25-4.25a.75.75 0 01-.11-1.055z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNC4xNjcwOSA3LjI3ODFDNC40Mjc3MSA2Ljk1NjE1IDQuODk5OTggNi45MDY0NCA1LjIyMTkyIDcuMTY3MDZMMTAgMTEuMDM1TDE0Ljc3ODEgNy4xNjcwNkMxNS4xMDAxIDYuOTA2NDQgMTUuNTcyMyA2Ljk1NjE1IDE1LjgzMyA3LjI3ODFDMTYuMDkzNiA3LjYwMDA0IDE2LjA0MzkgOC4wNzIzMSAxNS43MjE5IDguMzMyOTNMMTAuNDcxOSAxMi41ODI5QzEwLjE5NjggMTIuODA1NyA5LjgwMzI5IDEyLjgwNTcgOS41MjgxMyAxMi41ODI5TDQuMjc4MTMgOC4zMzI5M0MzLjk1NjE4IDguMDcyMzEgMy45MDY0NyA3LjYwMDA0IDQuMTY3MDkgNy4yNzgxWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgDropdownOutline20 as ReactComponent };